import { render, staticRenderFns } from "./LoadingRecall.vue?vue&type=template&id=365d56e9&scoped=true"
import script from "./LoadingRecall.vue?vue&type=script&lang=js"
export * from "./LoadingRecall.vue?vue&type=script&lang=js"
import style0 from "./LoadingRecall.vue?vue&type=style&index=0&id=365d56e9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "365d56e9",
  null
  
)

export default component.exports